// 小心处理，有循环依赖
import { ENV_TAG_MAP, devTool } from '@/dev-tool';

import { env as rawEnv } from './current';
export * from './type';

export const env = (() => {
  if (!devTool.usable || !devTool.envTag.initialValue) {
    return { ...rawEnv };
  }

  const envTagInfo = ENV_TAG_MAP[devTool.envTag.initialValue];
  // rawEnv 在 localhost/IP 访问时会被 current.ts 判定为本地代理入口。
  // 这里若被 dev-tool 覆盖 apiHost，会导致 local-api-proxy 失效。
  const shouldKeepRawApiHost = rawEnv.apiHost.includes('/local-api-proxy');
  return {
    ...rawEnv,
    deployEnv: envTagInfo.deployEnv,
    bizPlatform: envTagInfo.bizPlatform,
    apiHost: shouldKeepRawApiHost ? rawEnv.apiHost : envTagInfo.apiHost,
  };
})();
